import useFetchWithMsal from '../../hooks/useFetchWithMsal';
import React, { useState, useEffect } from 'react';
import { protectedResources, scopes } from "../../authConfig";
import Select from 'react-select';

function UserSelect({ type, displayName, value, onChange }) {
    const { execute } = useFetchWithMsal({
        scopes: scopes.callapi
    });

    const [selectData, setSelectData] = useState([]);
    const typeId = type + "Id";

    useEffect(() => {
        const fetchSelectData = async () => {
            try {
                const response = await execute('GET', protectedResources.getUsers.endpoint + "/");
                if (Array.isArray(response)) {
                    setSelectData(response);
                    console.log("Response:", response);
                } else {
                    console.log("Response is not an array:", response);
                    setSelectData([]);
                }
            } catch (error) {
                console.error("Error fetching user data:", error);
                setSelectData([]);
            }
        }
        fetchSelectData();
    }, [execute, type]);

    // React Selectのオプション形式に変換
    const selectOptions = selectData.map(data => ({
        value: data.id,
        label: data.displayName
    }));

    // 現在選択されている値をオブジェクトとして取得
    const selectedOption = selectOptions.find(option => option.value === value);

    // React Selectの変更ハンドラー
    const handleSelectChange = (selectedOption) => {
        const event = {
            target: {
                name: typeId,
                type: 'select-one',
                selectedOptions: [{ value: selectedOption ? selectedOption.value : '' }]
            }
        };
        onChange(event);
    };

    return (
        <Select
            id={type}
            name={typeId}
            value={selectedOption || null}
            onChange={handleSelectChange}
            options={selectOptions}
            placeholder="選択してください"
            noOptionsMessage={() => "ユーザーデータがありません"}
            isClearable
            className="basic-select"
            classNamePrefix="select"
        />
    );
}
export default UserSelect;